import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface AchievementCardProps {
  sharedMealsCount: number;
}

/**
 * Card displaying achievement/celebration message
 */
export const AchievementCard = memo(function AchievementCard({
  sharedMealsCount,
}: AchievementCardProps) {
  return (
    <button
      className={cn(
        "flex w-full items-center gap-4 rounded-3xl bg-white p-6",
        "transition-colors duration-200 hover:bg-gray-50 active:bg-gray-100",
        "text-left",
      )}
    >
      {/* Celebration Icon */}
      <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center">
        <span className="text-5xl">🎉</span>
      </div>

      {/* Content */}
      <div className="flex flex-1 flex-col gap-1">
        <h4 className={cn(textVariants.title3, "font-bold text-gray-900")}>Woo-hoo!</h4>
        <p className={cn(textVariants.bodySmall, "text-gray-700")}>
          You've shared {sharedMealsCount} meals with me already
        </p>
      </div>

      {/* Arrow */}
      <div className="flex-shrink-0">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-gray-400"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </button>
  );
});
